import ReactGA from "react-ga4";

import { REACT_APP_GA4_ID } from "../config/api";

const init = () => {
  if (!REACT_APP_GA4_ID) {
    console.warn(
      "[Analytics] REACT_APP_GA_ID no está definido en .env — GA4 deshabilitado."
    );
    return;
  }
  ReactGA.initialize(REACT_APP_GA4_ID);
};

const sendPageView = ({ page, title }) => {
  ReactGA.send({ hitType: "pageview", page, title });
};

const sendScrollDepth = (percent) => {
  ReactGA.event({
    category: "Scroll",
    action: "scroll_depth",
    label: `${percent}%`,
    value: percent,
  });
};

const sendExitClick = ({ url, label }) => {
  ReactGA.event({
    category: "Exit Click",
    action: "click_exit_link",
    label: label || url,
  });
};

const sendSiteSearch = ({ term, section }) => {
  ReactGA.event({
    category: "Search",
    action: "site_search",
    label: term,
    ...(section && { dimension1: section }),
  });
};

const sendAudioInteraction = ({ action, audioTitle, duration }) => {
  ReactGA.event({
    category: "Audio",
    action,
    label: audioTitle,
    ...(duration !== undefined && { value: Math.round(duration) }),
  });
};

const sendEvent = ({ category, action, label, value } = {}) => {
  ReactGA.event({ category, action, label, value });
};

export const analyticsService = {
  init,
  sendPageView,
  sendScrollDepth,
  sendExitClick,
  sendSiteSearch,
  sendAudioInteraction,
  sendEvent,
};
